import React from 'react';

interface ILoadingPanelProps {
    isLoading: boolean;
    color?: string;
}

// TODO: move to utility if needed.
const hexToRgb = (hex: string) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16),
          }
        : null;
};

const LoadingPanel: React.FC<ILoadingPanelProps> = (props) => {
    if (props.isLoading) {
        const rgb = hexToRgb(props.color);

        const style: React.CSSProperties = {
            position: 'absolute',
            height: '100%',
            width: '100%',
            top: 0,
            left: 0,
            background: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, .5)`,
        };

        return (
            <div style={{ position: 'relative' }}>
                <div style={style}>Loading</div>
                {props.children}
            </div>
        );
    }

    return <>{props.children}</>;
};

LoadingPanel.displayName = 'LoadingPanel';

LoadingPanel.defaultProps = {
    color: '#f1f1f1',
};

export default LoadingPanel;



// WEBPACK FOOTER //
// ./src/components/common/LoadingPanel.redesign.tsx